import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { Creators as BannersActions } from "../../store/ducks/banners";
import "./styles.css";

import Skeleton from "@material-ui/lab/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { defaultBanners } from "./default";
import { ContainerBanner, ContainerHighlights } from "./styles";
import { track } from "../../analytics";
import { hideImageOnError } from "../../util/imageFallback";

export default function Banner(props) {
  const dispatch = useDispatch();
  const [size, setSize] = useState("414x380");
  const [imageLoaded, setImageLoaded] = useState(false);
  const { data: banners, highlights, loading, error } = useSelector(state => state.banners);
  const history = useHistory();
  const [currentBanner, setCurrentBanner] = useState(0);
  const [bannerCount, setBannerCount] = useState(0);

  const handleNextBanner = () => {
    setCurrentBanner((prev) => (prev + 1) % bannerCount);
  }

  const handleBackBanner = () => {
    setCurrentBanner((prev) => (prev - 1 + bannerCount) % bannerCount);
  }

  const handleBanner = (position) => {
    setCurrentBanner(position);
  };

  useEffect(() => {
    if (banners[size]) {
      setBannerCount(banners[size].length)
    }
  }, [size, banners]);

  useEffect(() => {
    dispatch(BannersActions.getBannersRequest());
    dispatch(BannersActions.getHighlightsRequest());

    function bannersSize() {
      if (window.innerWidth >= 1440) {
        setSize("1440x426");
      } else if (window.innerWidth >= 1024 && window.innerWidth <= 1440) {
        setSize("1024x348");
      } else if (window.innerWidth >= 736 && window.innerWidth <= 1024) {
        setSize("1024x348");
      } else if (window.innerWidth >= 414 && window.innerWidth <= 736) {
        setSize("736x380");
      } else if (window.innerWidth >= 320 && window.innerWidth <= 414) {
        setSize("414x380");
      }
    }

    window.addEventListener("resize", bannersSize);
    bannersSize();

    return () => {
      window.removeEventListener("resize", bannersSize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bannerHeightMap = {
    "1440x426": 426,
    "1024x348": 348,
    "736x380": 380,
    "414x380": 380,
  };

  if (error !== null) {
    return (
      <ContainerBanner>
        <Carousel
          selectedItem={currentBanner}
          showStatus={false}
          showThumbs={false}
          swipeable={false}
          showArrows={false}
          infiniteLoop={false}
          showIndicators={false}
        >
          {defaultBanners &&
            defaultBanners[size].map((banner, key) => (
              <Link key={key} to={banner.link}>
                <div>
                  <img className="image-banner" src={banner.caminho_imagem} alt={banner.link} title={banner.link} />
                </div>
              </Link>
            ))}
        </Carousel>
        {defaultBanners[size] && defaultBanners[size].length > 1 && (
          <>
            <button type="button" className="nav-arrow nav-prev" onClick={handleBackBanner} aria-label="Voltar">
              <FiChevronLeft />
            </button>
            <button type="button" className="nav-arrow nav-next" onClick={handleNextBanner} aria-label="Avançar">
              <FiChevronRight />
            </button>
            <ul className="dots">
              {
                Array.from(Array(defaultBanners[size].length).keys()).map((item, index) => (
                  <li key={index} onClick={() => handleBanner(index)} >
                    <span className={currentBanner === index ? "active" : ""}></span>
                  </li>
                ))
              }
            </ul>
          </>
        )}
      </ContainerBanner>
    );
  }

  function trackSelectPromotion(banner, position) {
    track("select_promotion", { promotion_id: banner.uuid, creative_slot: position });
  }

  function getBannerProductsRequest(banner, position) {
    if (banner.tipo_link === "SEM_LINK") return;

    trackSelectPromotion(banner, position);
    return history.push(`/produtos/banner/${banner.uuid}`)
  }

  function renderHighlight(highlight) {
    const content = (
      <>
        <img
          className="highlight-image"
          src={highlight.base64Imagem}
          alt={highlight.titulo}
          title={highlight.titulo}
        />
        <div className="highlight-text">
          <strong>{highlight.titulo}</strong>
          <span>{highlight.subtitulo}</span>
        </div>
      </>
    );

    if (!highlight.link) {
      return <div className="highlight-card">{content}</div>;
    }

    return (
      <a
        className="highlight-card"
        href={highlight.link}
        target={highlight.tipo_link === "S" ? "_self" : "_blank"}
      >
        {content}
      </a>
    );
  }

  return (
    <>
      {(loading || !imageLoaded) && (
        <Skeleton
          variant="rect"
          animation="wave"
          width="100%"
          height={bannerHeightMap[size] || 380}
          style={{ borderRadius: 16 }}
        />
      )}
      <ContainerBanner style={{ display: (!loading && imageLoaded) ? undefined : 'none' }}>
        <Carousel
          selectedItem={currentBanner}
          onChange={(index) => setCurrentBanner(index)}
          showStatus={false}
          showThumbs={false}
          showArrows={false}
          autoPlay
          interval={5000}
          infiniteLoop
        >
          {banners[size] &&
            banners[size].map((banner, key) => (
              (banner.tipo_link === "LINK" || banner.tipo_link === "DIRECIONAMENTO_HOME") ? (
                <a key={banner.uuid} href={banner.tipo_link === "DIRECIONAMENTO_HOME" ? "/" : banner.link} target={banner.nova_aba ? "_blank" : "_self"} onClick={() => trackSelectPromotion(banner, key)} >
                  <div>
                    <img className="image-banner" src={banner.caminho_imagem} alt={banner.link} title={banner.link} style={{ transition: 'opacity 0.3s ease-in-out' }} onLoad={e => { e.target.style.opacity = 1; setImageLoaded(true); }} onError={e => { e.target.style.opacity = 1; hideImageOnError(e); setImageLoaded(true); }} />
                  </div>
                </a>
              ) : (
                <div style={{ cursor: "pointer" }} key={banner.uuid} onClick={() => getBannerProductsRequest(banner, key)}>
                  <img className="image-banner" src={banner.caminho_imagem} alt={banner.link} title={banner.link} style={{ transition: 'opacity 0.3s ease-in-out' }} onLoad={e => { e.target.style.opacity = 1; setImageLoaded(true); }} onError={e => { e.target.style.opacity = 1; hideImageOnError(e); setImageLoaded(true); }} />
                </div>
              )
            ))}
        </Carousel>
        {banners[size] && banners[size].length > 1 && (
          <>
            <button type="button" className="nav-arrow nav-prev" onClick={handleBackBanner} aria-label="Voltar">
              <FiChevronLeft />
            </button>
            <button type="button" className="nav-arrow nav-next" onClick={handleNextBanner} aria-label="Avançar">
              <FiChevronRight />
            </button>
            <ul className="dots">
              {
                Array.from(Array(banners[size].length).keys()).map((item, index) => (
                  <li key={index} onClick={() => handleBanner(index)} >
                    <span className={currentBanner === index ? "active" : ""}></span>
                  </li>
                ))
              }
            </ul>
          </>
        )}
      </ContainerBanner>
      {highlights && highlights.length > 0 && (
        <ContainerHighlights>
          {highlights.map(highlight => (
            <React.Fragment key={highlight.id}>
              {renderHighlight(highlight)}
            </React.Fragment>
          ))}
        </ContainerHighlights>
      )}
    </>
  );
}
